module.exports = __webpack_public_path__ + "static/media/comment-svgrepo-com (1).c0d1981c.svg";